import { render, staticRenderFns } from "./LocalPriceDelete.vue?vue&type=template&id=5706d020"
import script from "./LocalPriceDelete.vue?vue&type=script&lang=js"
export * from "./LocalPriceDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports